import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55ed82b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"-6px"} }, "附件：", -1))
const _hoisted_4 = { class: "button" }

import { ref, computed } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import UploadFile from '@/components/UploadFile'
import Modal from '@/hooks/modalType'
import type { commentItem } from '@/typings/api/followUpManage'
import { followRecordsDetail, followRecordsDelComment } from '@/api/gucangSales/followUpManage'
import xss from 'xss'

const __default__ = {
  name: 'ExportBtn'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Array,
    default: () => {
      return []
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  id: String
},
  setup(__props, { expose: __expose }) {

const props = __props
const hasfetch = ref(false)
const commentList = ref([])
const pageData = computed(() => {
  if (hasfetch.value) {
    return commentList.value
  }
  return props.data || []
})
const refresh = () => {
  followRecordsDetail(props.id).then((res) => {
    hasfetch.value = true
    commentList.value = res.data.commentList
  })
}
const handleDelCol = (row: commentItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelComment(row.id).then((res) => {
        DcMessage.success('删除成功')
        refresh()
      })
    }
  })
}
__expose({
  refresh
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "commit-list",
      key: item.id
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(item.createByName), 1),
        _createElementVNode("p", null, _toDisplayString(item.createTime), 1)
      ]),
      _createElementVNode("div", {
        innerHTML: _unref(xss)(item.content)
      }, null, 8, _hoisted_2),
      (item.fileId && item.fileId.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _createVNode(_unref(UploadFile), {
              value: item.fileId,
              "onUpdate:value": ($event: any) => ((item.fileId) = $event),
              view: "",
              valueType: "array"
            }, null, 8, ["value", "onUpdate:value"])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "text",
          onClick: ($event: any) => (handleDelCol(item)),
          danger: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("删除")
          ]),
          _: 2
        }, 1032, ["onClick"])), [
          [_directive_permission, __props.permissionPage.delCommit]
        ])
      ])
    ]))
  }), 128))
}
}

})